import { render, staticRenderFns } from "./SnackbarManager.vue?vue&type=template&id=af5d8f92&"
import script from "./SnackbarManager.vue?vue&type=script&lang=js&"
export * from "./SnackbarManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports